import React, { useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import BookingForm from '../BookingForm';
import SEO from '../SEO.js';
import './ServicePages.css';

const IVIMInjection = () => {
  const [showBookingForm, setShowBookingForm] = useState(false);

  const handleBookNow = () => {
    setShowBookingForm(true);
  };

  const handleCloseBooking = () => {
    setShowBookingForm(false);
    // Fix button color after form closes
    const buttons = document.querySelectorAll('.book-now-hero-btn, .cta-button, .sidebar-book-btn');
    buttons.forEach(button => {
      button.style.backgroundColor = 'var(--primary-color)';
      button.style.border = 'none';
      button.style.color = 'var(--white-color)';
    });
  };

  const benefits = [
    'Professional administration in the comfort of home',
    'No travel or waiting room time',
    'Reduced risk of hospital-acquired infections',
    'Personalized care and attention',
    'Flexible scheduling options',
    'Coordination with your doctors treatment plan'
  ];

  const services = [
    {
      name: 'Intravenous (IV) Injections',
      description: 'Administration of medications directly into the vein for immediate effect and maximum bioavailability.'
    },
    {
      name: 'Intramuscular (IM) Injections',
      description: 'Delivery of medications into muscle tissue for medications requiring slower, sustained absorption.'
    },
    {
      name: 'IV Fluid Therapy',
      description: 'Administration of fluids, electrolytes, and medications through intravenous infusion.'
    },
    {
      name: 'Medication Administration',
      description: 'Professional administration of prescribed injectable medications according to your doctor\'s orders.'
    }
  ];

  return (
    <div className="service-page iv-im-page">
      <SEO 
        title="IV & IM Injection Services at Home in Bangalore"
        description="Professional IV and IM injection services at home in Bangalore. Safe medication administration, IV fluid therapy, and drip services by qualified nurses."
        keywords="IV injection at home Bangalore, IM injection services, drip at home, home injection service, nurse for injection"
      />
      <div className="service-hero">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} md={12}>
              <div className="service-hero-content">
                <h1>IV & IM Injection Services</h1>
                <p>Professional administration of injectable medications in the comfort of your home</p>
                <Button className="book-now-hero-btn" onClick={handleBookNow}>
                  Book Appointment
                </Button>
              </div>
            </Col>
            <Col lg={6} md={12}>
              <div className="service-hero-image">
                <img src="/images/iv-injection.jpg" alt="IV & IM Injection Services" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Container className="service-content">
        <Row>
          <Col lg={8} md={12}>
            <div className="service-description">
              <h2>Professional Injection Services at Home</h2>
              <p>
                Our IV & IM injection services bring professional medication administration to your doorstep. 
                Our skilled nurses are trained to administer intravenous and intramuscular injections safely 
                and effectively, following your doctor's prescription and medical protocols.
              </p>
              <p>
                Whether you need regular injections for chronic conditions, a one-time treatment, or IV fluid therapy, 
                our nursing team ensures that you receive the right medication, in the right dose, through the right 
                route, at the right time—all in the comfort and convenience of your own home.
              </p>
              
              <h3>Our Injection Services</h3>
              <Row className="treatment-cards">
                {services.map((service, index) => (
                  <Col md={6} key={index} className="mb-4">
                    <Card className="treatment-card h-100">
                      <Card.Body>
                        <Card.Title>{service.name}</Card.Title>
                        <Card.Text>{service.description}</Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
              
              <h3 className="mt-4">Common Injectable Medications We Administer</h3>
              
            </div>
            <ul className="service-list">
                <li>Antibiotics and antiviral medications</li>
                <li>Pain management injections</li>
                <li>Vitamin B12 and other vitamin injections</li>
                <li>Insulin and diabetes management</li>
                <li>Hormone therapy injections</li>
                <li>Hydration therapy</li>
                <li>Iron deficiency treatments</li>
                <li>Post-surgery medication administration</li>
              </ul>
          </Col>
          
          <Col lg={4} md={12}>
            <div className="service-sidebar">
              <Card className="benefits-card">
                <Card.Header as="h5">Benefits of Home Injection Services</Card.Header>
                <Card.Body>
                  <ul className="benefits-list">
                    {benefits.map((benefit, index) => (
                      <li key={index}>{benefit}</li>
                    ))}
                  </ul>
                  <div className="d-grid gap-2 mt-4">
                    <Button variant="primary" onClick={handleBookNow} className="sidebar-book-btn">
                      Request Injection Service
                    </Button>
                  </div>
                </Card.Body>
              </Card>
              
              <Card className="why-choose-card mt-4">
                <Card.Header as="h5">Why Choose Our Injection Services?</Card.Header>
                <Card.Body>
                  <ul className="why-choose-list">
                    <li>Licensed and experienced nursing professionals</li>
                    <li>Strict adherence to safety protocols</li>
                    <li>Proper handling and disposal of medical waste</li>
                    <li>Coordination with your healthcare provider</li>
                    <li>Comprehensive documentation of treatments</li>
                  </ul>
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row>

        <Row className="mt-5">
          <Col md={12}>
            <div className="cta-section text-center">
              <h3>Need Professional Injection Services?</h3>
              <p>Our skilled nursing team is ready to administer your prescribed medications safely at home.</p>
              <Button size="lg" onClick={handleBookNow} className="cta-button">
                Schedule an Appointment
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
      
      <BookingForm 
        show={showBookingForm} 
        handleClose={handleCloseBooking} 
        defaultService="IV & IM Injection"
      />
    </div>
  );
};

export default IVIMInjection;
